module.exports = __webpack_public_path__ + "static/media/LandingImport.b0145bd0.svg";